import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4 mr-4" }
const _hoisted_2 = { class: "flex flex-row space-x-4 items-end" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row space-x-4"
}
const _hoisted_4 = { class: "flex-grow md:w-9/12" }
const _hoisted_5 = {
  key: 0,
  class: "md:w-3/12 ml-auto"
}
const _hoisted_6 = {
  key: 1,
  class: "md:w-3/12 h-0"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex flex-col space-y-4" }
const _hoisted_9 = { class: "flex flex-row space-x-4" }

import AvatarWithColor from "@/components/Friends/AvatarWithColor.vue";
import TextMedium from "@/components/Texts/TextMedium.vue";
import { useUsersStore } from "@/store/useUsersStore";
import { watch } from "vue";
import ThreeDotsIcon from "@/components/Icons/ThreeDotsIcon.vue";
import InputCheckbox from "@/components/Form/InputCheckbox.vue";
import { computed, ComputedRef, ref } from "vue";
import { useAuthStore } from "@/store/useAuthStore";
import { FriendInfos } from "@/interfaces/FriendInfos";
import ButtonSecondary from "@/components/Buttons/ButtonSecondary.vue";
import InputColor from "@/components/Form/InputColor.vue";
import { useFriendsStore } from "@/store/useFriendsStore";
import { useDialogsStore } from "@/store/useDialogsStore";
import BottomSheet from "@/components/Menus/BottomSheet.vue";
import TitleMedium from "@/components/Titles/TitleMedium.vue";
import ButtonPrimary from "@/components/Buttons/ButtonPrimary.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserManageView',
  props: {
    friend_info: {}
  },
  emits: ["update:selectedUsers"],
  setup(__props: any, { emit: __emit }) {

const authStore = useAuthStore();
const friendsStore = useFriendsStore();

const props = __props;

const { getUserById } = useUsersStore();
const user = computed(() => {
  return getUserById(props.friend_info.friendId);
});

const color: ComputedRef<string> = computed(() => {
  if (props.friend_info.friendId === authStore.currentUser?.id) {
    return authStore.currentUser.color;
  } else {
    if (props.friend_info.friendRequestInfos) {
      return props.friend_info.friendRequestInfos.from ===
        props.friend_info.friendId
        ? props.friend_info.friendRequestInfos.colorFrom
        : props.friend_info.friendRequestInfos.colorTo;
    }
  }
  return "#ffffff";
});

const selectedUsers = computed(() => {
  return authStore.currentUser?.selectedUsers || [];
});

const emit = __emit;

const updateSelectedUsers = (event: Event) => {
  const selectedUsersNew = authStore.currentUser?.selectedUsers;
  if (event.target instanceof HTMLInputElement && selectedUsersNew) {
    if (user.value) {
      if (event.target.checked) {
        selectedUsersNew.push(user.value.id);
      } else {
        const index = selectedUsersNew.indexOf(user.value.id);
        if (index !== -1) {
          selectedUsersNew.splice(index, 1);
        }
      }
    }
    authStore.updateSelectedUsers(selectedUsersNew);
  }
};

const colorCustom = ref(color.value);

watch(
  () => colorCustom.value,
  () => {
    if (props.friend_info.friendRequestInfos) {
      friendsStore.updateColor(
        colorCustom.value,
        props.friend_info.friendRequestInfos.from ===
          props.friend_info.friendId,
        props.friend_info.friendRequestInfos.from,
        props.friend_info.friendRequestInfos.to
      );
    } else {
      authStore.updateColor(colorCustom.value);
    }
  },
  { deep: true }
);

const dialogsStore = useDialogsStore();

const friendCustomDialog = dialogsStore.createNewDialog();
const friendDeleteDialog = dialogsStore.createNewDialog();

const toggleFriendDeleteDialog = () => {
  if (dialogsStore.dialogs[friendDeleteDialog]) {
    dialogsStore.closeOnlyOneModal(friendDeleteDialog);
  } else {
    dialogsStore.openModalNoClosing(friendDeleteDialog);
  }
};

const toggleFriendCustomDialog = () => {
  if (dialogsStore.dialogs[friendCustomDialog]) {
    dialogsStore.closeOnlyOneModal(friendCustomDialog);
  } else {
    dialogsStore.openModalNoClosing(friendCustomDialog);
  }
};

const isOpen = computed(() => {
  return dialogsStore.dialogs[friendCustomDialog];
});

const deleteFriend = () => {
  if (props.friend_info.friendRequestInfos) {
    // delete friend
    friendsStore.deleteFriendRequest(
      props.friend_info.friendRequestInfos.from,
      props.friend_info.friendRequestInfos.to
    );
    // update selected users
    const selectedUsersNew = authStore.currentUser?.selectedUsers;
    const index = selectedUsersNew.indexOf(props.friend_info.friendId);
    if (index !== -1) {
      selectedUsersNew.splice(index, 1);
    }
    authStore.updateSelectedUsers(selectedUsersNew);
    // close modal
    dialogsStore.closeOnlyOneModal(friendDeleteDialog);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(AvatarWithColor, {
          color: color.value,
          class: "flex-none h-12 mb-1"
        }, null, 8, ["color"]),
        _createVNode(InputCheckbox, {
          name: user.value.id.toString(),
          modelValue: selectedUsers.value.includes(user.value.id),
          onChange: updateSelectedUsers,
          id: user.value.id.toString(),
          class: "w-1/12 mb-1"
        }, null, 8, ["name", "modelValue", "id"]),
        _createVNode(TextMedium, {
          class: "flex-grow ml-2 md:ml-0",
          text: user.value.name
        }, null, 8, ["text"]),
        _createVNode(ThreeDotsIcon, {
          class: "text-white h-6",
          onClick: toggleFriendCustomDialog
        })
      ]),
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(InputColor, {
                name: "color",
                placeholder: "color",
                id: "color",
                modelValue: colorCustom.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((colorCustom).value = $event)),
                label: "Change color"
              }, null, 8, ["modelValue"])
            ]),
            (props.friend_info.friendRequestInfos)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(ButtonSecondary, {
                    text: "Delete",
                    class: "w-full",
                    onClick: toggleFriendDeleteDialog
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6))
          ]))
        : _createCommentVNode("", true)
    ]),
    (props.friend_info.friendRequestInfos)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(BottomSheet, {
            "dialog-id": _unref(friendDeleteDialog),
            "out-side-closable": true,
            "all-draggable": false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(TitleMedium, { text: "Delete friend" }),
                _createVNode(TextMedium, { text: "Are you sure you want to delete this friend?" }),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(ButtonSecondary, {
                    text: "Cancel",
                    class: "w-1/2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(dialogsStore).closeOnlyOneModal(_unref(friendDeleteDialog))))
                  }),
                  _createVNode(ButtonPrimary, {
                    text: "Delete",
                    class: "w-1/2",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (deleteFriend()))
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["dialog-id"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})